/* src/app/modules/print-cards/components/render-cards/render-cards.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=render-cards.component.css.map */
